/**
 * Adresses des écrans voisins. Elles reprennent celles de la coquille (`cheminEcran`) sans l'importer : la coquille
 * charge les écrans des lots, un import en retour créerait une boucle. `chemins.test.ts` garde l'accord des deux.
 */
export const CHEMINS_VOISINS = {
  pilotage: { ecran: 'D01', chemin: '/pilotage' },
  arbre: { ecran: 'D04', chemin: '/dossier/arbre' },
  heritiers: { ecran: 'D05', chemin: '/fiche-heritier' },
  biens: { ecran: 'D15', chemin: '/dossier/titre' },
  documents: { ecran: 'D09', chemin: '/documents' },
  messages: { ecran: 'D06', chemin: '/boite' },
  facturation: { ecran: 'D08', chemin: '/facturation' },
  estimation: { ecran: 'D04c', chemin: '/dossier/estimation' },
  // L64 (juge du 30/10, U1) : le démarrage guidé, onglet du dossier.
  demarrage: { ecran: 'D17', chemin: '/dossier/demarrage' },
} as const;

/** Un lien interne du dossier garde le dossier courant : sans `?dossier=`, l'écran voisin n'a rien à ouvrir. */
export function avecDossier(chemin: string, idDossier: string | null | undefined): string {
  if (!idDossier || chemin.startsWith('#')) return chemin;
  return `${chemin}${chemin.includes('?') ? '&' : '?'}dossier=${encodeURIComponent(idDossier)}`;
}
